'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactVirtualized = require('react-virtualized');

require('./PaginatedLoader.css');

require('react-datepicker/dist/react-datepicker.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This is a generic class that turns a set of paginating responses
 * into an infinite scroller, it requires some parameters be passed in.
 *
 * The key example of this is a scrolling list of all recordings the user has
 *
 * It is recommended to take a look at existing components that utilize
 * the class for a reference implementation.
 */
var PaginatedLoader = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PaginatedLoader, _Component);

  function PaginatedLoader() {
    (0, _classCallCheck3.default)(this, PaginatedLoader);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PaginatedLoader.__proto__ || (0, _getPrototypeOf2.default)(PaginatedLoader)).call(this));

    _this.state = {
      // If are more pages that _can_ be paginated
      isMoreToLoad: true,
      // Amount of rows to render
      rowCount: 90
    };

    // The query (cursor) to run for the "next page"
    _this.loadMorePaginationQuery = '';
    // Items loaded so far
    _this.itemList = [];
    // The page we are targeting loading
    _this.targetPage = 0;
    // Pages we've gotten so far
    _this.gotPage = 0;
    // Page that is actively being loaded
    _this.loadingPage = 0;
    // Number of entries per page
    _this.pageSize = 30;

    // If we are currently fetching a new page of results
    _this.currentlyFetching = false;

    // Callbacks that need to be called for succesfully loading
    // this page of results
    _this.registeredFetchCallbacks = {};

    // Used to call update method
    _this._infiniteScrollerRef = null;

    _this.rowRenderer = _this.rowRenderer.bind(_this);
    _this.isRowLoaded = _this.isRowLoaded.bind(_this);
    _this.loadMoreRows = _this.loadMoreRows.bind(_this);
    _this.startFetchTo = _this.startFetchTo.bind(_this);
    _this.getRowHeight = _this.getRowHeight.bind(_this);
    _this.getRecordingUrl = _this.getRecordingUrl.bind(_this);
    return _this;
  }

  // eslint-disable-next-line


  (0, _createClass3.default)(PaginatedLoader, [{
    key: 'getRowHeight',
    value: function getRowHeight(_ref) {
      var index = _ref.index;

      return this.props.rowHeight;
    }
  }, {
    key: 'getRecordingUrl',
    value: function getRecordingUrl() {
      if (this.loadMorePaginationQuery === '') {
        this.loadMorePaginationQuery = this.props.getEmptyPaginationQuery();
      }

      // console.log(this.loadMorePaginationQuery);

      return this.props.getUrlFromQuery(this.loadMorePaginationQuery);
    }

    // Return if the given row is loaded

  }, {
    key: 'isRowLoaded',
    value: function isRowLoaded(_ref2) {
      var index = _ref2.index;

      return index < this.itemList.length;
    }

    // Render a single row with the Recording Detail object

  }, {
    key: 'rowRenderer',
    value: function rowRenderer(_ref3) {
      var index = _ref3.index,
          key = _ref3.key,
          style = _ref3.style;

      var object = this.itemList[index];

      return this.props.renderRow({ index: index, key: key, style: style, object: object });
    }

    /**
     * Starts a fetch to the given page index if it's needed
     *
     * @param {int}  pageIndex Page index to go to
     * @param {func} callback  Callback to call when done
     */

  }, {
    key: 'startFetchTo',
    value: function startFetchTo(pageIndex, callback) {
      var _this2 = this;

      // Make sure that we fetch to at least the new target pageIndex
      if (pageIndex > this.targetPage) {
        this.targetPage = pageIndex;
      }

      // If we've already gotten the page - then just return
      // and call the callback immediatley
      if (this.gotPage >= pageIndex) {
        callback();
        return;
      }

      // Register the callback
      if (this.registeredFetchCallbacks[pageIndex]) {
        this.registeredFetchCallbacks[pageIndex].push(callback);
      } else {
        this.registeredFetchCallbacks[pageIndex] = [callback];
      }

      // If we are currently fetching then we know we don't need to start
      if (!this.currentlyFetching) {
        // Mark us as starting to fetch the next page
        this.currentlyFetching = true;
        console.log('starting fetch');

        // Start fetching the next page - this handles
        // continuing to fetch more pages if needed
        var performNextFetch = function performNextFetch() {
          var fetchUrl = _this2.getRecordingUrl();

          // Mark us as beginning to fetch the next page
          _this2.loadingPage += 1;

          return fetch(fetchUrl)
          // If the request is throttled, throw and error and
          // retry in a bit
          .then(function (res) {
            // Throttled error type
            if (res.status === 429) {
              throw new Error('Throttling Error');
            }
            return res;
          }).then(function (response) {
            return response.json();
          }).then(function (jsonResponse) {
            console.log(jsonResponse);

            // Store response data in list
            _this2.itemList = _this2.itemList.concat(jsonResponse.results);

            _this2.setState({
              rowCount: _this2.itemList.length + _this2.pageSize * 2
            });

            // Mark the page as succesfully
            _this2.gotPage = _this2.loadingPage;

            // Notify all listeners for this page that all
            // objects have been fetched
            if (_this2.registeredFetchCallbacks[_this2.gotPage]) {
              _this2.registeredFetchCallbacks[_this2.gotPage].forEach(function (cb) {
                cb();
              });
              _this2.registeredFetchCallbacks[_this2.gotPage] = null;
            }

            // Check if there is another page to load
            if (jsonResponse.next) {
              // Extract the query part of the URL
              var query = jsonResponse.next.match(/\?.*/)[0];
              _this2.loadMorePaginationQuery = query;

              // Check if we need to continue fetching more pages
              // If we do, then fetch another page
              if (_this2.targetPage > _this2.gotPage) {
                performNextFetch();
              } else {
                // Otherwise denote that we are done fetching
                _this2.currentlyFetching = false;
              }
            } else {
              // If there are no more pages then immediately stop
              // and mark that we have no more pages to load
              _this2.setState({
                isMoreToLoad: false,
                rowCount: _this2.itemList.length
              });
              _this2.currentlyFetching = false;
            }
          })
          // Catch errors and retry in a bit (throttling errors)
          .catch(function (error) {
            console.log(error);
            return setTimeout(performNextFetch, 5000);
          });
        };

        performNextFetch();
      }
    }
  }, {
    key: 'loadMoreRows',
    value: function loadMoreRows(_ref4) {
      var _this3 = this;

      var stopIndex = _ref4.stopIndex;

      if (stopIndex < this.itemList.length || !this.state.isMoreToLoad) {
        return;
      }

      var pages = Math.round((stopIndex + 1) / this.pageSize);
      console.log(pages);

      var retPromise = new _promise2.default(function (res) {
        // Register fetched pageIndex
        _this3.startFetchTo(pages, res);
      });

      console.log(retPromise);

      // eslint-disable-next-line
      return retPromise;
    }
  }, {
    key: 'forceRefresh',
    value: function forceRefresh(loadMorePaginationQuery) {
      this.loadMorePaginationQuery = loadMorePaginationQuery;

      // Items loaded so far
      this.itemList = [];
      // The page we are targeting loading
      this.targetPage = 0;
      // Pages we've gotten so far
      this.gotPage = 0;
      // Page that is actively being loaded
      this.loadingPage = 0;

      this.setState({ isMoreToLoad: true });
      this._infiniteScrollerRef.resetLoadMoreRowsCache(true);
      this._listRef.forceUpdateGrid();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactVirtualized.WindowScroller,
          null,
          function (_ref5) {
            var height = _ref5.height,
                isScrolling = _ref5.isScrolling,
                onChildScroll = _ref5.onChildScroll,
                scrollTop = _ref5.scrollTop;
            return _react2.default.createElement(
              _reactVirtualized.InfiniteLoader,
              {
                ref: function ref(child) {
                  _this4._infiniteScrollerRef = child;
                },
                isRowLoaded: _this4.isRowLoaded,
                loadMoreRows: _this4.loadMoreRows,
                rowCount: _this4.state.rowCount,
                minimumBatchSize: _this4.pageSize
              },
              function (_ref6) {
                var onRowsRendered = _ref6.onRowsRendered,
                    registerChild = _ref6.registerChild;
                return _react2.default.createElement(
                  _reactVirtualized.AutoSizer,
                  { disableHeight: true },
                  function (_ref7) {
                    var width = _ref7.width;
                    return _react2.default.createElement(_reactVirtualized.List, {
                      ref: function ref(child) {
                        _this4._listRef = child;
                        registerChild(child);
                      },
                      autoHeight: true,
                      height: height,
                      isScrolling: isScrolling,
                      onScroll: onChildScroll,
                      scrollTop: scrollTop,
                      onRowsRendered: onRowsRendered,
                      rowCount: _this4.state.rowCount,
                      rowHeight: _this4.getRowHeight,
                      rowRenderer: _this4.rowRenderer,
                      width: width
                    });
                  }
                );
              }
            );
          }
        )
      );
    }
  }]);
  return PaginatedLoader;
}(_react.Component), _class.propTypes = {
  // Height in pixels of the row - requires a simple
  // modification below to make it dependant on the index
  rowHeight: _react.PropTypes.number,

  // The function that actually renders a row given
  // index, key, style, and the object itself
  renderRow: _react.PropTypes.func,

  // The URL query to run on the first run - returns string
  getEmptyPaginationQuery: _react.PropTypes.func,

  // This function is passed the URL Query fragment and is expected
  // to generate and return the full URL
  getUrlFromQuery: _react.PropTypes.func
}, _class.defaultProps = {
  rowHeight: 250
}, _temp);
exports.default = PaginatedLoader;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/PaginatedLoader/PaginatedLoader.js
 ** module id = 1384
 ** module chunks = 0
 **/